const courses = [
    {
        key: "C101",
        name: "Advanced CSS and Sass",
        category: "WebDesign",
        img: "https://img-a.udemycdn.com/course/750x422/2459100_87b1_6.jpg",
        price: 60,
        description:
            "Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem tempore.",
        instructor: {
            name: "Jonas Schmedtmann",
            img: "https://i.ibb.co/bznS1Zx/smswajan.jpg",
        },
    },
    {
        key: "C102",
        name: "Docker and Kubernetes",
        category: "Development",
        img: "https://i.ytimg.com/vi/Mi3Lx7yk3Hg/maxresdefault.jpg",
        price: 45,
        description:
            "Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem tempore.",
        instructor: {
            name: "Stephen Grider",
            img: "https://i.ibb.co/bznS1Zx/smswajan.jpg",
        },
    },
    {
        key: "C102",
        name: "Ultimate AWS Certification",
        category: "IT Certification",
        img: "https://elysiumacademy.org/wp-content/uploads/2018/12/aws.jpg",
        price: 85,
        description:
            "Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem tempore.",
        instructor: {
            name: "Stephane Maarek",
            img: "https://i.ibb.co/bznS1Zx/smswajan.jpg",
        },
    },
    {
        key: "C102",
        name: "Microsoft Excel Advanced",
        category: "MS Office",
        img: "https://i.ytimg.com/vi/RdTozKPY_OQ/maxresdefault.jpg",
        price: 32,
        description:
            "Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem tempore.",
        instructor: {
            name: "Kyle Pew",
            img: "https://i.ibb.co/bznS1Zx/smswajan.jpg",
        },
    },
    {
        key: "C102",
        name: "Adobe XD UI/UX",
        category: "MS Office",
        img:
            "https://www.elegantthemes.com/blog/wp-content/uploads/2020/06/ux-ui-design-courses-bootcamps-featured-image-scaled.jpg",
        price: 89,
        description:
            "Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem tempore.",
        instructor: {
            name: "Daniel Walter Scott",
            img: "https://i.ibb.co/bznS1Zx/smswajan.jpg",
        },
    },
    {
        key: "C102",
        name: "Content Writing Masterclass",
        category: "MS Office",
        img:
            "https://leverageedu.com/blog/wp-content/uploads/2019/11/Content-Writing-Courses-1.png",
        price: 26,
        description:
            "Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem tempore.",
        instructor: {
            name: "Kylie Genner",
            img: "https://i.ibb.co/bznS1Zx/smswajan.jpg",
        },
    },
];

export default courses;
